import {
  Container,
  Typography,
  Button,
} from '@material-ui/core';

import React, { useEffect, useState, useRef } from 'react'

import { doSpeechRecog, initSpeechRecognition } from './speechRecognition.js';
import { isSafariOnMac, avatarPic, domain, contactEmail } from './config';

export default function IntroScreen() {
  const READY = 0;
  const RUNNING = 1;
  const FINISHED = 2;

  const [text, setText] = useState('');
  const [testRunningStatus, setTestRunningStatus] = useState(READY);
  const speechRecognitionControl = useRef();
  
  useEffect(() => {
    if (window.localStorage['profile_completed']) window.location = '/sessions';
    // if (isSafariOnMac()) alert('Unfortunately your browser (Safari on Mac) is not supported. Please try a different browser.');
  }, [])

  function finishTest() {
      speechRecognitionControl.current.stop();
      setTestRunningStatus(FINISHED);
  }

  async function beginTest() {
      setTestRunningStatus(RUNNING);
      const finalRecog = (text) => {
          setText(text);
          setTestRunningStatus(FINISHED);
      }
      speechRecognitionControl.current = await doSpeechRecog(finalRecog, setText, 10000);
  }




  return (
    <Container component="main" maxWidth="sm">
      { domain.endsWith('wisdom.bot') && <Typography><img src="https://wisdom.bot/assets/img/wb-logo.png"/></Typography> }
      <Typography variant="h5">Welcome!</Typography>

      <Typography paragraph>
        Your will speak with Athena, an artificial intelligence (AI) life coach, who is here to support you.
      </Typography>
      <img style={{marginLeft: 'auto', marginRight: 'auto', display: 'block', width: '200px', marginBottom: '20px', }} src={avatarPic}></img>
      
      <Typography paragraph>
        You can speak about any topic related to personal development of emotional well-being. 
        For example: challenges in your relationship, goals you wish to achieve, a decision you're wrestling with. 
        Athena will support you with thoughtful questions and suggestions. At the end of the session, you will see key takeaways from from the conversation. 
        You can come back and speak to hear again at any time in the future.
      </Typography>
      
      <Typography paragraph>
        Because this is a spoken conversation please <b>ensure your microphone &#127908; and speakers &#128266; are ready</b>. 
        Try to speak clearly.
        Athena will respond after you stop speaking for a few seconds. 
        You can always interrupt her by clicking the <span style={{color:"red", fontSize: 20}}>&#8855;</span> icon.
        <br/>
        
        <br/>
        {(testRunningStatus == READY) &&
        <div>
         <div>Click the button below to test your audio now. </div>

         <Button
            variant="contained"
            onClick={beginTest}>
            Begin Audio Test</Button>
          </div>
        }
        
      </Typography>

      <Typography paragraph>
    {testRunningStatus == RUNNING &&
        <div style={{paddingLeft: '20px', paddingRight: '20px'}}>
          <div>
          Please speak into your microphone. You should see the text appear below.
          </div>
          <div>
            You said:
            <div style={{ color: 'darkred', backgroundColor: 'lightgrey' }}>&nbsp;{text}</div>
          </div>
        <Button variant="contained" 
          color="secondary" 
          onClick={finishTest}>Stop</Button>
        </div>
    }
      
    
</Typography>

      <Typography paragraph>
        On the next screen, please fill out a short profile. This will allow Athena to personalize her questions and advice for you.
      </Typography>

      <Typography paragraph>
        When you're ready click Next below.
      </Typography>

      <Button variant="contained" color="primary" onClick={() => { window.location = '/profile'; }}>Next</Button>
      
      <Typography paragraph>
        <br/>
          <small>
            Your information will be kept confidential. Any advice given is not professional advice, and is for entertainment only. Please consult a professional if you are experiencing acute psychological distress or life challenges. This is an experimental AI technology.
            For more details, refer to: <a href="/terms.html" target="_blank">Terms of Use</a>, <a href="/privacy.html" target="_blank">Privacy Policy</a>, <a href={ 'mailto:' + contactEmail }>Contact</a>.
          </small>
      </Typography>
      
    </Container>
  );
}

// // To use:
// import React from 'react';
// import ReactDOM from 'react-dom';
// import PersonalityForm from './PersonalityForm';

// ReactDOM.render(<PersonalityForm />, document.getElementById('root'));